/* @flow */
import { isArray, groupBy, reduce } from 'lodash';
import { TARGET_TYPES } from 'entities/Message';
import type { Target } from 'entities/Message';
import type {
  RecipientInput,
  MessageTargetFilterInput,
} from 'chat/queries/__generated__/ComposerRecipients';

const makeRecipient = (target: Target, filters: MessageTargetFilterInput[]): RecipientInput => {
  return {
    type: target.type.replace('_target', ''),
    uuid: target.uuid || '',
    filters,
  };
};

export function putMessageRecipientsForTargets(targets: Target[]): Array<RecipientInput> {
  return targets.map((target: Target) => {
    if (
      (target.type === 'group_target' || target.type === 'district_target') &&
      isArray(target.selectedFilters) &&
      target.selectedFilters.length > 0
    ) {
      const groupedFilters = groupBy(target.selectedFilters, filt => filt.type);
      const finalFiltered: Array<MessageTargetFilterInput> = reduce(
        groupedFilters,
        (arr, filters, key) => {
          arr.push({ [key]: filters.map<string>(value => value.value.id) });
          return arr;
        },
        []
      );

      return makeRecipient(target, finalFiltered);
    } else if (target.type === 'group_target' && target.role) {
      return makeRecipient(target, [{ roles: [target.role] }]);
    }
    return makeRecipient(target, []);
  });
}

export function allTargetsAreGroups(targets: Target[]): boolean {
  return !targets.some(t => t.type !== TARGET_TYPES.GROUP_TARGET);
}
